import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { Text, Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import { useTopicPage } from "../TopicPageContext";
import TopicPageHeaderTitle from "./TopicPageHeaderTitle";
import TopicPageHeaderLabel from "./TopicPageHeaderLabel";
import TopicPageHeaderH1 from "./TopicPageHeaderH1";
const Wrapper = styled(Flex)`
  ${media.up("medium")} {
    padding-left: 16px;
    padding-right: 16px;
  }

  padding-bottom: 24px;
`;
const TopicPageHeader = (props)=>{
    const { topic , label , buttons  } = props;
    const { view  } = useParams();
    const isTrashView = view === "trash";
    const isArchiveView = view === "archive";
    const isActivityView = view === "activity";
    const { title , description , isRootTopic , rootTopicOrSelf  } = topic;
    const { followersCount  } = rootTopicOrSelf || {};
    const { isPartOfTopic , isOwnerOrAdmin , disabled  } = useTopicPage();
    const showFollowersCount = !isPartOfTopic && isRootTopic && followersCount ? followersCount : undefined;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            flexDirection: "column",
            alignItems: "center",
            children: [
                label && /*#__PURE__*/ _jsx(TopicPageHeaderLabel, {
                    label: label,
                    disabled: !(isOwnerOrAdmin && !disabled)
                }),
                (isArchiveView || isTrashView || isActivityView) && /*#__PURE__*/ _jsx(TopicPageHeaderH1, {
                    title: `${isTrashView ? "Trash" : isActivityView ? "Activity" : "Archived"} in ${title}`
                }),
                !view && !label && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TopicPageHeaderTitle, {
                            topic: topic
                        }),
                        showFollowersCount && /*#__PURE__*/ _jsx(Text, {
                            fontSize: 1,
                            color: "black.60",
                            mt: "4px",
                            textAlign: "center",
                            children: `${showFollowersCount} follower${showFollowersCount !== 1 ? "s" : ""}`
                        }),
                        description && /*#__PURE__*/ _jsx(Text, {
                            mt: showFollowersCount ? "8px" : "4px",
                            textAlign: "center",
                            lineHeight: "24px",
                            children: description
                        })
                    ]
                }),
                buttons
            ]
        })
    });
};
export default TopicPageHeader;
